const RewardsFalse = ({ className }: { className: string }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.20044 22.8C0.537724 22.1373 0.537724 21.0629 1.20044 20.4001L20.3996 1.20095C21.0623 0.538242 22.1368 0.538241 22.7995 1.20095C23.4622 1.86367 23.4622 2.93814 22.7995 3.60085L3.60034 22.8C2.93762 23.4628 1.86315 23.4628 1.20044 22.8Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.19995 1.19995C1.86267 0.537236 2.93714 0.537236 3.59985 1.19995L22.799 20.3991C23.4618 21.0619 23.4618 22.1363 22.799 22.799C22.1363 23.4618 21.0619 23.4618 20.3991 22.799L1.19995 3.59985C0.537239 2.93713 0.537239 1.86266 1.19995 1.19995Z"
      fill="currentColor"
    />
  </svg>
)

export default RewardsFalse
